import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';
import CartoonButton from '../components/CartoonButton.component';
import { CartoonTextField } from '../components/CartoonForm.component';
import FortuneWheel from '../components/FortuneWheel.component';
import BuyMeACoffee from '../components/BuyMeACoffee.component';
import { WELCOME_PARTS } from '../constants';
import { useLobbyCreate } from '../hooks/useLobbySocket';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const [joinId, setJoinId] = useState('');
  const { createLobby, createdLobbyId } = useLobbyCreate();

  // Navigate once lobby is created
  useEffect(() => {
    if (createdLobbyId) {
      navigate(`/lobby/${createdLobbyId}`);
    }
  }, [createdLobbyId, navigate]);

  const handleJoinGame = () => {
    let value = joinId.trim();
    if (value.includes('lobby/')) {
      value = value.split('lobby/').pop()?.split('/')[0].split('?')[0] ?? value;
    }
    value = value.slice(0, 32);
    if (value) navigate(`/lobby/${value}`);
  };

  const handleJoinKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleJoinGame();
  };

  return (
    <Box sx={{ background: 'linear-gradient(135deg, #FF6F61 30%, #6B5B95 90%)', height: '100vh', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Box sx={{ position: 'fixed', top: 12, right: 16, zIndex: 9999 }}><BuyMeACoffee /></Box>
    <Container maxWidth="sm">
      <Box display="flex" flexDirection="column" alignItems="center" gap="16px">
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            fontFamily: '"Comic Sans MS", cursive, sans-serif',
            fontWeight: 'bold',
            color: 'white',
            textShadow: '2px 2px 0 rgba(0,0,0,0.3)',
            textAlign: 'center',
          }}
        >
          🎡 Who Pays?
        </Typography>

        <FortuneWheel isWelcome welcomeParts={WELCOME_PARTS} />

        <Box mt={2} width="100%">
          <CartoonTextField
            label="Lobby ID or invite link"
            variant="outlined"
            value={joinId}
            onChange={e => setJoinId(e.target.value.slice(0, 512))}
            onKeyDown={handleJoinKeyDown}
            fullWidth
            sx={{ background: 'rgba(255,255,255,0.9)', borderRadius: '15px' }}
          />
        </Box>

        <Box display="flex" flexDirection="column" gap="12px" width="100%">
          <CartoonButton
            variant="contained"
            onClick={createLobby}
            fullWidth
            sx={{ background: '#ff4081' }}
          >
            Create Lobby
          </CartoonButton>

          <CartoonButton
            variant="contained"
            onClick={handleJoinGame}
            disabled={!joinId.trim()}
            fullWidth
            sx={{ background: '#3f51b5' }}
          >
            Join Existing Lobby
          </CartoonButton>
        </Box>
      </Box>
    </Container>
    </Box>
  );
};

export default LandingPage;
